import React, {Component} from 'react';

import ModalAddWallPost from 'components/modals/ModalAddWallPost';

import {t} from 'l10n';

import 'sass/headers/HeaderMemberWallPosts.scss';

class HeaderMemberWallPosts extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false
        }
    }

    render() {
        let {onPostAddSuccess} = this.props;

        let {showModal} = this.state;

        return (
            <header className="memberWallPosts">
                <div className="content">
                    <h1>{t('My posts on The Wall')}</h1>
                    <div className="text-header-memberwallposts">
                        <div />

                        <ModalAddWallPost
                            show={showModal}
                            closeFn={() => this.setState({showModal: false})}
                            onSuccess={onPostAddSuccess}
                        />

                        <div>
                            <div className="add-post-button" onClick={() => this.setState({showModal: true})}>{t('New post')}</div>
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}

export default HeaderMemberWallPosts;


// WEBPACK FOOTER //
// ./src/components/member/HeaderMemberWallPosts.js